<template>
    <div class="card" style="min-width: 200px;min-height:100px" >
        <!--<h5 class="card-header">-->
            <!--老师详情{{teacher_id}}-->
        <!--</h5>-->
        <div class="card-body">
            <label>电话：{{teacher.phone}}</label>
            <br/>
            <label>教授学科：<span v-for="(subject,index) in teacher.subjects" :key="index">{{subject}} </span> </label>
            <br/>
            <label>教授年级：<span v-for="(grade,index) in teacher.grades" :key="index">{{grade}} </span></label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TeacherDetail",
        data() {
            return {
                insertForm:{
                    subject_id:'',
                    teacher_subject_id:'',
                },
                teachers:[],
            }
        },
        created() {

        },
        props:{
            teacher:'',
        },
        computed: {
            subjects() {
                return JSON.parse(localStorage.config).subjects;
            },
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>